import { Container } from './styled';

export function Switch(props) {
    const {
        ref,
        label,
        onChange,
        checked,
        disabled,
        name
    } = props;
    return (
        <Container>
            <span>{label}</span>
            <label htmlFor='switch' className='switch' >
                <input
                    name={name}
                    id='switch'
                    type='checkbox'
                    ref={ref}
                    onChange={() => onChange()}
                    checked={checked}
                    disabled={disabled}
                />
                <span className='slider round' />
            </label>
        </Container>
    );
}           